"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = function _default(date) {
  return (0, _moment["default"])(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
};

exports["default"] = _default;